var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8 7.10457 7.10457 8 6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6ZM7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6Z",
    fill: "#3351FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.648569 5.47553C0.450477 5.79712 0.450477 6.20288 0.648569 6.52447C0.715184 6.63261 0.79043 6.74836 0.874026 6.8699C1.16768 7.29684 1.51593 7.72613 1.91688 8.12772C3.03619 9.24879 4.4078 10 6 10C7.5922 10 8.96381 9.24879 10.0831 8.12772C10.4841 7.72613 10.8323 7.29684 11.126 6.8699C11.2096 6.74836 11.2848 6.63261 11.3514 6.52447C11.5495 6.20288 11.5495 5.79712 11.3514 5.47553C11.2848 5.36739 11.2096 5.25164 11.126 5.1301C10.8323 4.70316 10.4841 4.27387 10.0831 3.87228C8.96381 2.75121 7.5922 2 6 2C4.4078 2 3.03619 2.75121 1.91688 3.87228C1.51593 4.27387 1.16768 4.70316 0.874026 5.1301C0.79043 5.25164 0.715184 5.36739 0.648569 5.47553ZM10.302 6.3032C10.3765 6.19495 10.4425 6.09327 10.5 6C10.4425 5.90673 10.3765 5.80505 10.302 5.6968C10.0397 5.31538 9.72977 4.93371 9.37545 4.57883C8.38426 3.58608 7.25297 3 6 3C4.74703 3 3.61574 3.58608 2.62455 4.57883C2.27023 4.93371 1.96029 5.31538 1.69795 5.6968C1.62349 5.80505 1.55745 5.90673 1.5 6C1.55745 6.09327 1.62349 6.19495 1.69795 6.3032C1.96029 6.68462 2.27023 7.06629 2.62455 7.42117C3.61574 8.41392 4.74703 9 6 9C7.25297 9 8.38426 8.41392 9.37545 7.42117C9.72977 7.06629 10.0397 6.68462 10.302 6.3032Z",
    fill: "#3351FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d5726872af84be266fb6124d47b89668.svg";
export { ForwardRef as ReactComponent };